// extracted by mini-css-extract-plugin
module.exports = {"container":"cookieBanner_container__CEdhE","all":"cookieBanner_all__3z5k7","logo":"cookieBanner_logo__3FXBL","title":"cookieBanner_title__1kHCq","content":"cookieBanner_content__1u83V","text":"cookieBanner_text__3KSXO","actions":"cookieBanner_actions__dVE_T"};
    if(module.hot) {
      // 1790670276998
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  